import React, { useState } from "react";
import MuiButton from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import pxToRem from "libs/pxToRem";
import Modal from "components/styled/modal/Modal";
import styled from "@material-ui/core/styles/styled";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import { Typography } from "@material-ui/core";
import { SolicitudConsumoAnalisisResponse } from "api/types/originacion/services/analisisSolicitudTypes";

const DesistirSolicitud: React.FC<{
  handleDesistir: (motivo: string) => void;
  isLoading: boolean;
  solicitud: SolicitudConsumoAnalisisResponse;
}> = ({ handleDesistir, isLoading, solicitud }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const canSubmit = motivo !== "" && !isLoading;

  const formatMotivo = (text: string): string => {
    if (!text || text.trim() === "") return "";

    let formatted = text.trim();

    formatted = formatted.toLowerCase();

    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);

    if (!formatted.endsWith(".")) {
      formatted += ".";
    }

    return formatted;
  };

  const handleClose = () => {
    setModalIsOpen(false);
    setMotivo("");
  };

  const handleSubmit = () => {
    const motivoFormateado = formatMotivo(motivo);
    handleDesistir(motivoFormateado);
  };

  return (
    <>
      <Button onClick={(e) => setModalIsOpen(!modalIsOpen)}>Desistir</Button>
      <Modal
        maxWidth="sm"
        opened={modalIsOpen}
        onClose={handleClose}
        title="Desistir solicitud de consumo"
        dialogActions={
          <ModalButton disabled={!canSubmit} onClick={handleSubmit}>
            {isLoading && "Desistiendo..."}
            {!isLoading && "Desistir"}
          </ModalButton>
        }
      >
        <ModalContent>
          <IdSection>
            <DescriptionOutlinedIcon
              style={{ color: "hsl(263, 55%, 53%)", fontSize: pxToRem(20) }}
            />
            <IdText>Solicitud #{solicitud.id}</IdText>
          </IdSection>

          <TextField
            onChange={(e) => {
              setMotivo(e.target.value);
            }}
            value={motivo}
            placeholder="Motivo"
            multiline
            minRows={4}
            variant="outlined"
            style={{ width: pxToRem(380), marginTop: pxToRem(5) }}
          />
        </ModalContent>
      </Modal>
    </>
  );
};
export default DesistirSolicitud;

const Button = styled(MuiButton)({
  height: pxToRem(28),
  marginLeft: pxToRem(8),
  backgroundColor: "#f44336",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#f35858",
  },
});
Button.defaultProps = {
  variant: "contained",
  size: "small",
};

const ModalButton = styled(MuiButton)({
  backgroundColor: "#f44336",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#f35858",
  },
  minWidth: pxToRem(140),
});
ModalButton.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
  fullWidth: false,
};

const ModalContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(16),
  padding: pxToRem(16),
});

const IdSection = styled("div")({
  backgroundColor: "#f5f5f5",
  borderLeft: `${pxToRem(4)} solid hsl(190, 63%, 57%)`,
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
  borderRadius: pxToRem(4),
  display: "flex",
  alignItems: "center",
  gap: pxToRem(10),
});

const IdText = styled(Typography)({
  fontSize: pxToRem(15),
  fontWeight: 600,
  color: "#424242",
  margin: 0,
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
});
